import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

export default class Dropdown extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.any,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired,
      })
    ).isRequired,
    errorMessage: PropTypes.string,
    e2e: PropTypes.string,
  };

  static defaultProps = {
    placeholder: 'Bitte wählen...',
    disabled: false,
  };

  state = {
    focus: false,
  };

  onChange = (event) => {
    const option = this.props.options.find(
      (opt) => String(opt.value) === String(event.target.value)
    );
    if (option) {
      this.props.onChange(option.value, this.props.name);
    }
  };

  onFocus = () => {
    this.setState({ focus: true });
  };

  onBlur = () => {
    this.setState({ focus: false });
  };

  render() {
    const {
      className,
      disabled,
      e2e,
      errorMessage,
      helpText,
      label,
      name,
      onClick,
      options,
      placeholder,
    } = this.props;
    // Make sure to allow "0" as valid select option
    const value = !String(this.props.value).length ? 'PLACEHOLDER' : this.props.value;
    const rootClassName = classNames(styles.dropdown, {
      [className]: className,
      [styles['disabled']]: disabled,
      [styles['invalid']]: errorMessage,
      [styles['focus']]: this.state.focus,
    });

    return (
      <div className={rootClassName}>
        {label && (
          <div className={styles.label} aria-hidden="true">
            {label}
          </div>
        )}
        <div className={styles.wrapper} tabIndex={-1} onFocus={this.onFocus} onBlur={this.onBlur}>
          {value === 'PLACEHOLDER' && <div className={styles.placeholder}>{placeholder}</div>}
          <select
            name={name}
            aria-label={label ? label.replace('*', ' Pflichtangabe') : undefined}
            className={styles.select}
            value={value}
            onChange={this.onChange}
            onClick={onClick}
            disabled={disabled}
            data-e2e={e2e}
          >
            {value === 'PLACEHOLDER' && (
              <option value="PLACEHOLDER" disabled>
                {placeholder}
              </option>
            )}
            {options.map((option) => {
              return (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              );
            })}
          </select>
        </div>
        {helpText && <p className={styles.helpText}>{helpText}</p>}
        {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
      </div>
    );
  }
}
